
<div style="display: flex; align-items: center;">
    @if(!isMobile) {
        @if(showImage) {
            <span style="min-width: 46px; width: 46px; height: 46px; margin-right: 8px; display: flex;">
                @if(imageUrl) {
                    <img style="width: inherit; object-fit: contain;" 
                        [src]="imageUrl" 
                        [alt]="name" 
                    />
                }
            </span>
        }
    
        <span class="grid-color-preview" 
                [style.backgroundColor]="'#' + color"
                style="margin-right: 8px; flex-shrink: 0;">
        </span>
    }

    <span #wrapper style="overflow: hidden; text-overflow: ellipsis">{{ name }}</span>
</div>